import { css } from "@emotion/react";

import type { SizeType } from "@zapier/reporting/src/hooks/useSize";

export const pillOverride = css`
  & > span {
    border-radius: 50px;
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export function getTooltipPosition(size: SizeType) {
  return size === "large" ? "bottom" : ("bottom right" as const);
}
